import * as Types from '../../graphql/hirer-types.generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NotesAttachmentHistoryQueryVariables = Types.Exact<{
  applicationNotesInput: Types.ApplicationNotesInput;
  applicationAttachmentsV2Input: Types.ApplicationAttachmentsV2Input;
}>;

export type NotesAttachmentHistoryQuery = {
  __typename: 'Query';
  applicationNotesV2:
    | {
        __typename: 'ApplicationNotesResponseSuccess';
        result: Array<{
          __typename: 'ApplicationNoteV2';
          id: string;
          createdUserFirstname: string;
          createdUserLastname: string;
          createdUserId: string;
          content: string;
          createdDate: any;
        }>;
      }
    | { __typename: 'ResponseError'; error: Types.ResponseErrorReason };
  applicationAttachmentsV2:
    | {
        __typename: 'ApplicationAttachmentsV2ResponseSuccess';
        result: Array<{
          __typename: 'ApplicationAttachmentV2';
          blobId: string;
          attachmentType: Types.ApplicationAttachmentType;
          hasConvertedPdf: boolean;
          fileName?: string | null;
          uploadedDate?: any | null;
          uploadedUser?: string | null;
          legacyAttachmentId?: string | null;
        }>;
      }
    | { __typename: 'ResponseError'; error: Types.ResponseErrorReason };
};

export const NotesAttachmentHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'NotesAttachmentHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'applicationNotesInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ApplicationNotesInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'applicationAttachmentsV2Input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ApplicationAttachmentsV2Input' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationNotesV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'applicationNotesInput' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ApplicationNotesResponseSuccess',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createdUserFirstname',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'createdUserLastname',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdUserId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdDate' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ResponseError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationAttachmentsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'applicationAttachmentsV2Input',
                  },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ApplicationAttachmentsV2ResponseSuccess',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'blobId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attachmentType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasConvertedPdf' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fileName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uploadedDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uploadedUser' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'legacyAttachmentId',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ResponseError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useNotesAttachmentHistoryQuery__
 *
 * To run a query within a React component, call `useNotesAttachmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesAttachmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesAttachmentHistoryQuery({
 *   variables: {
 *      applicationNotesInput: // value for 'applicationNotesInput'
 *      applicationAttachmentsV2Input: // value for 'applicationAttachmentsV2Input'
 *   },
 * });
 */
export function useNotesAttachmentHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    NotesAttachmentHistoryQuery,
    NotesAttachmentHistoryQueryVariables
  > &
    (
      | { variables: NotesAttachmentHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NotesAttachmentHistoryQuery,
    NotesAttachmentHistoryQueryVariables
  >(NotesAttachmentHistoryDocument, options);
}
export function useNotesAttachmentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotesAttachmentHistoryQuery,
    NotesAttachmentHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NotesAttachmentHistoryQuery,
    NotesAttachmentHistoryQueryVariables
  >(NotesAttachmentHistoryDocument, options);
}
export function useNotesAttachmentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NotesAttachmentHistoryQuery,
        NotesAttachmentHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NotesAttachmentHistoryQuery,
    NotesAttachmentHistoryQueryVariables
  >(NotesAttachmentHistoryDocument, options);
}
export type NotesAttachmentHistoryQueryHookResult = ReturnType<
  typeof useNotesAttachmentHistoryQuery
>;
export type NotesAttachmentHistoryLazyQueryHookResult = ReturnType<
  typeof useNotesAttachmentHistoryLazyQuery
>;
export type NotesAttachmentHistorySuspenseQueryHookResult = ReturnType<
  typeof useNotesAttachmentHistorySuspenseQuery
>;
export type NotesAttachmentHistoryQueryResult = Apollo.QueryResult<
  NotesAttachmentHistoryQuery,
  NotesAttachmentHistoryQueryVariables
>;
